import React from 'react';
import { Spinner, Card, Button, Modal, Form, Alert } from 'react-bootstrap';
import axios from 'axios';
import { Constants } from "../constants";
import GridSystem from './grid_system';
import SiteMenu from "./menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import ReactGA from "react-ga4";


class LandingPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: props.location.state.user,
            showMigrationNotice: true
        };

        this.createCards = this.createCards.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleContractorSubmit = this.handleContractorSubmit.bind(this);
        this.handleContractorPin = this.handleContractorPin.bind(this);
        this.showButton = this.showButton.bind(this);
    }
    componentDidMount() {
        /*console.log(ReactGA);
        console.log(window.location.pathname);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        ReactGA.send("pageview");
        ReactGA.pageview("landing");
    */}

    handleClose() {
        this.setState({ showModal: false });
    }
    handleContractorPin(event) {
        this.setState({
            contractorPin: event.target.value
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '30px', backgroundColor: '#1F419B' }} variant="primary" disabled>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>;
        }
        else {
            return <Button variant="primary" name="confirm" onClick={this.handleContractorSubmit} style={{ backgroundColor: '#1F419B' }}>
                Submit
            </Button>;
        }
    }
    handleContractorSubmit() {
        this.setState({ loading: true });
        axios.get(`${Constants.apiURL}/api/Identity/LoginContractor`, {
            params: {
                username: this.state.user.username,
                contractorPin: this.state.contractorPin
            }
        }).then(response => {
            if (response.data) {
                this.setState({
                    showModal: false,
                    loading: false
                });
                this.props.history.push({
                    pathname: "/contractor_portal",
                    state: {
                        user: this.state.user,
                        contractor: response.data
                    }
                });
            }
            else {
                alert('Invalid access code.');
                this.setState({
                    loading: false
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    createCards(items) {
        return items.filter((item) => { return item.visible }).map(item =>
            <Card className='text-center landing-card' style={{ width: '250px', maxHeight:'207px', border: 0, cursor: 'pointer' }} onClick={item.onClick} visible={item.visible}>
                <Card.Body style={{ backgroundColor: '#1F419B', color: 'white', height: '40px', padding: '0px', border: 0 }}>
                    <Card.Title style={{ textAlign: 'center', margin: 0, height: '100%', padding: '0.5rem', border: 0 }}>{item.label}</Card.Title>
                </Card.Body>
                <Card.Img variant="bottom" fluid src={item.imageSrc} style={{minHeight:'160px'}} />
            </Card>
        );
    }

    render() {
        const actionItems = [{
            label: 'Request Service',
            imageSrc: './Request Service.jpg',
            visible: this.state.user.isInternal || this.state.user.hasAccount,
            onClick: () => {
                this.props.history.push({
                    pathname: "/service_request",
                    state: {
                        user: this.state.user,
                        typeofrequest: "Equipment Inquiry"
                    }
                });
            }
        }, {
            label: 'Open Orders',
            imageSrc: './Track Open Orders.jpg',
            visible: this.state.user.isInternal || this.state.user.hasAccount,
            onClick: () => {
                this.props.history.push({
                    pathname: "/open_orders",
                    state: {
                        user: this.state.user
                    }
                });
            }
        }, {
            label: 'Building Log',
            imageSrc: './Building Service Log.jpg',
            visible: this.state.user.isInternal || this.state.user.hasAccount,
            onClick: () => {
                this.props.history.push({
                    pathname: "/building_service_view",
                    state: {
                        user: this.state.user
                    }
                });
            }
        }, {
            label: 'Job Bid List',
            imageSrc: './Contractor Bid List.jpg',
            visible: true,
            onClick: () => {
                this.setState({ showModal: true });
            }
        }, {
            label: 'Training',
            imageSrc: './training.png',
            visible: true,
            onClick: () => {
                this.props.history.push({
                    pathname: "/training",
                    state: {
                        user: this.state.user
                    }
                });
            }
        }, {
            label: 'Order History',
            imageSrc: './Review Order History.jpg',
            visible: this.state.user.isInternal || this.state.user.hasAccount,
            onClick: () => {
                this.props.history.push({
                    pathname: "/orders",
                    state: {
                        user: this.state.user
                    }
                });
            }
        }, {
            label: 'Pay Invoices',
            imageSrc: './Pay Invoices.jpg',
            visible: this.state.user.isInternal || this.state.user.isFullAccess,
            onClick: () => {
                this.props.history.push({
                    pathname: "/account_selection",
                    state: {
                        user: this.state.user,
                        nextPath: '/open_invoices'
                    }
                });
            }
        }, {
            label: 'Manage Accounts',
            imageSrc: './My Profile.jpg',
            visible: true,
            onClick: () => {
                this.props.history.push({
                    pathname: "/manage_accounts",
                    state: {
                        user: this.state.user
                    }
                });
            }
            }];
        const showModal = this.state.showModal;

        return (
            <div class='landing-grid'>
                <SiteMenu user={this.state.user} currentPage='landingPage' />
                <Alert variant="warning" dismissible show={this.state.showMigrationNotice} onClose={() => this.setState({ showMigrationNotice: false })} style={{ margin: '10px 25px 0 25px' }}>
                    <Alert.Heading style={{ fontSize: '18px' }}>Important Notice: Boland Client Portal Migration</Alert.Heading>
                    <p>
                        To improve your portal experience and service reliability, we are transitioning our back-end system from Dynamics GP to NetSuite.
                    </p>
                    <p style={{ marginBottom: '0.5rem' }}><strong>What to Expect:</strong></p>
                    <ul style={{ marginBottom: '0.5rem' }}>
                        <li><strong>Migration Date:</strong> Early 2027.</li>
                        <li><strong>Portal Availability:</strong> The portal will be offline / in read-only mode during the maintenance window.</li>
                        <li><strong>Data &amp; History:</strong> All existing account balances, invoice histories, service logs, and pending requests will automatically transfer over. No manual data entry is required on your end.</li>
                    </ul>
                    <p style={{ marginBottom: 0 }}>
                        If you have urgent requests, please submit them before January 2027. For questions or support during this transition, contact us at <a href="mailto:clientportal@boland.com">clientportal@boland.com</a>.
                    </p>
                </Alert>
                <Modal show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Contractor Portal Login</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Enter your contractor access code:</Form.Label>
                                <Form.Control autoFocus onChange={this.handleContractorPin} maxLength="20" />
                            </Form.Group>
                            <Form.Label style={{ fontStyle: 'italic' }}>Not sure of your access code?<br />Please contact your Boland salesperson</Form.Label>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'flex-start' }}>
                        {this.showButton()}
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Form.Label style={{
                    paddingLeft: '25px',paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', paddingTop: '10px'
                }}>
                    Welcome to our portal, {this.state.user.firstname}</Form.Label><br />
                <Form.Label style={{ paddingLeft: '25px', paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontSize: '15px' }}>
                    Use the Quick Access menu below or select from the menu bar above.</Form.Label>
                <GridSystem className='landing-grid' colCount={4} md={3}>{this.createCards(actionItems)}</GridSystem>
            </div>
        );
    }
}
export default LandingPage;